import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState, useRef } from 'react'
import axios from 'axios'

function CercaArtista() {
    const navigate = useNavigate()
    const [formData, setFormData] = useState('')
    const [foodTruck, setFoodTruck] = useState({})
    const [msg, setMsg] = useState({ msg1: null, msg2: null })//per controllo campo obbligatorio in tipologia from input
    const [msgEsitoQuery, setMsgEsitoQuery] = useState({ msgTipologiaPredef: null, msgTipologiaInput: null })
    const [msgCity, setMsgCity] = useState(null)
    const [cityFilter, setCityFilter] = useState(null)//città/regione filtrate ad ogni change dell'input 'città'
    const [città, setCittà] = useState([])//città/regioni trovate in MYSQL con axios 

    const cittàValue = useRef()
    const cityFilterId = useRef()//per display 'block' o 'none' del div delle città selezionabili
    const cercaPerCittàDiv = useRef()// div del cerca foodTruck per città o regione

    function handleChangeCittà(e) {//RICERCA PER CITTA'
        const { value } = e.target
        setFormData({ città: value }); setMsgCity(null); setMsgEsitoQuery({ msgTipologiaPredef: null, msgTipologiaInput: null }); setMsg({})
        let filter = []; setCityFilter(null)
        città.some((elem, index) => {//filtraggio città da input 'città'
            if (value.toLowerCase() !== '') {
                // let result = elem.substring(0, value.length)//result è l'elemento [città] con length uguale a value.length'
                if (elem.toLowerCase().includes(value.toLowerCase())) {//match tra input 'città' e array città
                    filter.push(elem)
                }
            }
        })
        if (filter.length > 0) {//se in input 'città' viene trovata una città in array 'citta'
            filter = filter.filter((value, index) => filter.indexOf(value) === index)//tolgo le città ripetute
            console.log(filter)
            setCityFilter(filter)
            cityFilterId.current.style.display = 'block'
        } else { cityFilterId.current.style.display = "none" }
    }
    const cittàCliccata = async (elem) => {//RICERCA PER CITTA' CLICCATA DA BANNER CITTA' TROVATE
        cittàValue.current.value = elem
        setFormData({ ...formData, città: elem })

        const foodTruckByGenere = foodTruck.filter(item =>
            (item.città.toUpperCase() === elem.toUpperCase() || item.regione.toUpperCase() === elem.toUpperCase()) && (item.accettazione === 'true'))
        if (foodTruckByGenere.length === 0) {
            setMsgCity(`Nessun foodTruck trovato a ${elem}`)
            return
        }
        navigate('/foodTruckPerGenere', { replace: true, state: { genere: foodTruckByGenere, luogo: elem, mode: 'luogo' } })
    }
    function handleChangeGenere(e) {
        setMsgEsitoQuery({ msgTipologiaPredef: null, msgTipologiaInput: null })
        const { value } = e.target
        setFormData(value)
        setMsg({ msg1: null, msg2: null })
    }
    function handleChangeSelect(e) {//cerca dal select (tipicizzata)
        setMsgEsitoQuery({ msgTipologiaPredef: null, msgTipologiaInput: null }); setMsg({})
        const { value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        getFoodTrucks(inputValue, 'msgTipologiaPredef')
    }
    function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        if (formData.città) {// cerca artista per regione o città
            if (!cityFilter) {
                setMsg({ msg2: `*** Nessun foodTruck trovato in ${formData.città}  ***` })
            } else {
                const foodTruckByGenere = foodTruck.filter(item =>
                    (item.città.toUpperCase() === cityFilter[0].toUpperCase() || item.regione.toUpperCase() === cityFilter[0].toUpperCase()) && (item.accettazione === 'true'))
                navigate('/foodTruckPerGenere', { replace: true, state: { genere: foodTruckByGenere, luogo: cityFilter[0], mode: 'luogo' } })
                console.log(foodTruckByGenere)
            }
            return
        } else
            if (formData === '') {// cerca per genere da input utente
                setMsg({ msg1: '*** Campo obbligatorio ***' }); return
            }
        getFoodTrucks(formData, 'msgTipologiaInput')
    }
    async function getFoodTrucks(inputValue, msgTipologia) {//query foodTruck from select or from input
        try {
            const vb = inputValue.split(' '); let foodTruckByGenere; console.log('vb:', vb)
            vb.some(x => {// è come forEach ma si può fermare il ciclo quando foodTruckByGenere.length !== 0
                foodTruckByGenere = foodTruck.filter(e =>// se inputValue è 'cucina italiana' filtro 'cucina' e 'italiana' separatamente
                    e.genere.toUpperCase().includes(x.toUpperCase()) === true
                    || e.soggetto.toUpperCase().includes(x.toUpperCase()) === true
                    && e.accettazione !== 'false'
                    && e.accettazione !== 'rejection'
                )
                return foodTruckByGenere.length !== 0
            })

            if (foodTruckByGenere.length === 0) {
                setTimeout(() => {
                    setMsgEsitoQuery({ [msgTipologia]: '*** Nessun foodTruck trovato ***' })
                }, 200)
            } else {
                navigate('/foodTruckPerGenere', { replace: true, state: { tipoCucina: inputValue, genere: foodTruckByGenere, mode: 'genere' } })
            }
        } catch (err) { console.log(err) }
    }
    useEffect(() => {//caricamento Città Regione da server nodejs (MYSQL)
        let arr = []
        axios.post('/getArtisti/DESC/id').then(res => {
            setFoodTruck(res.data.filter(item => item.sezione === "truck"))
            const response = res.data
            response.forEach(element => {//carico 'setCittà' con le città presenti in MYSQL
                if (element.sezione === 'truck')
                arr.push(element.città, element.regione)
            })
            setCittà(arr)
        })
        //--------------- cancella div delle città trovate con click sul body ---------------
        cittàValue.current.addEventListener('change', () => {
            document.addEventListener('mouseup', onMouseUp)
            function onMouseUp() {//gestione input 'cittàValue' al click nel body del documento 
                if (cittàValue.current !== '') cittàValue.current.value = ''
                if (cityFilterId.current.style.display === "block") {
                    cityFilterId.current.style.display = "none"
                    document.removeEventListener('mouseup', onMouseUp)
                }
            }
        })
    }, [])
    // useEffect(() => { console.log('foodTruck:', foodTruck) }, [foodTruck])
    return (<>
        <div className='container' style={{ backgroundColor: 'whitesmoke', marginTop: '3rem' }}>
            <hr />
            <div style={{ margin: '2rem 0' }}>
                <h3 style={{ textAlign: 'center' }}>TROVA FOODTRUCK</h3>
                <form onSubmit={handleSubmit}>
                    {/* ---------------------- CERCA PER TIPOLOGIA PREDEFINITA -------------------- */}
                    <div className="input-group mb-3">
                        <span className="input-group-text" id="basic-addon1" style={{ color: 'navy', fontWeight: '600', border: '1px solid grey' }}>
                            Cerca per tipo
                        </span>
                        <select className="form-select  fw-bold" aria-label="Default select example"
                            style={{ display: 'inline', marginRight: '5%', border: '1px solid grey' }}
                            name="tipologia" onChange={handleChangeSelect} >
                            <option value=''></option>
                            <option value="Cucina italiana tradizionale">Cucina italiana tradizionale</option>
                            <option value="Hamburger & Fast Food">Hamburger & Fast Food</option>
                            <option value="Etnica internazionale">Etnica/Internazionale</option>
                            <option value="Vegetariana">Vegetariana</option>
                            <option value="Vegana">Vegana</option>
                            <option value="Dolci & Gelati">Dolci & Gelati</option>
                            <option value="Bar Cocktail Birre Frullati Centrifugati">Bar/Cocktail/Birre/Frullati/Centrifugati</option>
                            <option value="Griglia & Barbecue">Griglia & Barbecue</option>
                        </select>
                    </div>
                    {msgEsitoQuery.msgTipologiaPredef && <p style={{ color: 'red' }}><i>{msgEsitoQuery.msgTipologiaPredef}</i></p>}

                    {/* ---------------- CERCA PER INPUT DELL'UTENTE ------------------- */}
                    <div className="input-group mb-3">
                        <div className='cercaArtistiDiv' style={{ border: '1px solid grey' }}>
                            <img src="https://img.icons8.com/?size=100&id=59878&format=png&color=000000"
                                className='cercaArtisti' />
                        </div>
                        <input className='form-control' aria-label="Città" aria-describedby="basic-addon1"
                            style={{ display: 'inline', border: '1px solid grey' }}
                            type='text'
                            placeholder='es. Cucina Italiana'
                            onChange={handleChangeGenere}
                            maxLength={45} />
                        <button type='submit'
                            style={{ fontSize: 'small', marginRight: '5%', border: '1px solid grey' }}>
                            <b><i>Cerca</i></b>
                        </button>
                    </div>
                    {msg.msg1 && <p style={{ color: 'red' }}><i>{msg.msg1}</i></p>}
                    {msgEsitoQuery.msgTipologiaInput && <p style={{ color: 'red' }}><i>{msgEsitoQuery.msgTipologiaInput}</i></p>}

                    <div className='text-center'>
                        <button className='btn btn-success' type='button' onClick={() => {
                            if (cercaPerCittàDiv.current.style.display === 'block') {
                                cercaPerCittàDiv.current.style.display = 'none'
                            }
                            else { cercaPerCittàDiv.current.style.display = 'block' }
                        }}>CERCA PER REGIONE O CITTA'
                        </button>
                    </div>

                    {/* ---------------- CERCA CON CHIAVE CITTA' ------------------- */}
                    <div ref={cercaPerCittàDiv} style={{ display: 'none' }}>
                        <div className="input-group mb-1 mt-2">
                            <span className="input-group-text" id="basic-addon1"
                                style={{ color: 'navy', fontWeight: '600', border: '1px solid grey' }}>
                                Città/Regione
                            </span>
                            <input className='form-control' aria-label="Città" aria-describedby="basic-addon1"
                                style={{ display: 'inline', border: '1px solid grey' }}
                                type='text'
                                name='città'
                                placeholder='Es. Lazio'
                                onChange={handleChangeCittà}
                                ref={cittàValue}
                            />
                            <button type='submit'
                                style={{ fontSize: 'small', marginRight: '5%', border: '1px solid grey' }}>
                                <b><i>Cerca</i></b>
                            </button>
                        </div>
                        <div>
                            {msg.msg2 && <p style={{ color: 'red' }}>{msg.msg2}</p>}
                            {msgCity && <p style={{ color: 'red' }}><i>{msgCity}</i></p>}
                        </div>
                    </div>

                    {/* ----------------- BANNER CITTA' TROVATE -------------------- */}
                    <div ref={cityFilterId} style={{
                        border: '1px solid black', zIndex: '1',
                        padding: '5px',
                        position: 'absolute',
                        left: '6%',
                        width: '14rem',
                        display: 'none',
                        backgroundColor: 'whitesmoke'
                    }}>
                        {cityFilter &&
                            cityFilter.map((elem, index) => (
                                <span className='filterCity' key={index}>
                                    <p style={{ cursor: 'pointer', fontSize: 'medium', margin: '-6px 0' }} onClick={() => { cittàCliccata(elem) }}>{elem}
                                    </p>
                                    {cityFilter.length !== index + 1 && <hr />}
                                </span>
                            ))}
                    </div>
                </form>
            </div>
            <hr />
        </div><br />
    </>)
}
export default CercaArtista